import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import ShortcodeGenerator from './Generator'

const widgets = [
  { widget: 'searchform', shortcodeName: 'search', label: 'Search', options: {
    search_template_id: { type: 'search', label: 'Apply a Saved Search' },
    background: { type: 'color', label: 'Add Background Color' },
    margin: { type: 'number', label: 'Add Margin to Form' },
    padding: { type: 'number', label: 'Add Padding to Form' },
    radius: { type: 'number', label: 'Add Corner Radius to Form' },
    advanced: { type: 'show', label: 'Include Advanced Search' },
    pills: { type: 'show', label: 'Display Applied Filters' },
    beds: { type: 'hide', label: 'Exclude Beds Field' },
    baths: { type: 'hide', label: 'Exclude Baths Field' },
    types: { type: 'hide', label: 'Exclude Types Menu (only applies to "Advanced Search Form")' },
    price: { type: 'hide', label: 'Exclude Price' },
    locations: { type: 'hide', label: 'Exclude Locations' },
    streamlined: { type: 'hide', label: 'Exclude More' },
    submit_text: { type: 'text', label: 'Customize Search Button Text' },
  }},
  {
    widget: 'searchbutton', shortcodeName: 'search', label : 'Search Button', options: {
      search_template_id: { type: 'search', label: 'Apply a Saved Search' },
      submit_text: { type: 'text', label: 'Customize Search Button Text' },
    }, defaults: {
      hide: 'price,beds,baths,streamlined,types,locations',
    }
  },
  { widget: 'searchmap', shortcodeName: 'map', label: 'Map', options: {
    search_template_id: { type: 'search', label: 'Apply a Saved Search' },
    height: { type: 'number', label: 'Set Height' },
    searchinmap: { type: 'hide', label: 'Exclude Search In Map Button' },
    zoom: { type: 'hide', label: 'Exclude Zoom Buttons' },
    draw: { type: 'hide', label: 'Exclude Draw Area Button' },
    satellite: { type: 'hide', label: 'Exclude Satellite Button' },
  }},
  { widget: 'searchresultscount', shortcodeName: 'search_results_count', label: 'Search Results Count', options: {
    search_template_id: { type: 'search', label: 'Apply a Saved Search' },
    link_to_search: { type: 'boolean', label: 'Link To Results', value: '1' },
    link_to_search_target: { type: 'boolean', label: 'Open In New Window', value: '_blank' },
  }},
  { widget: 'authform', shortcodeName: 'signin', label: 'Sign In' },
  { widget: 'contactform', shortcodeName: 'contact', label: 'Contact' },
  { widget: 'cmaform', shortcodeName: 'cma', label: 'Market Value' },
  { widget: 'calculator', shortcodeName: 'calculator', label: 'Mortgage Calculator' },
  { widget: 'nav', shortcodeName: 'nav', label: 'Navigation Links', options: {
    search: { type: 'hide', label: 'Exclude Search Field' },
    dashboard: { type: 'hide', label: 'Exclude Dashboard Field' },
    listings: { type: 'hide', label: 'Exclude Listings Field' },
    searches: { type: 'hide', label: 'Exclude Searches Field' },
    signin: { type: 'hide', label: 'Exclude Sign In Field' },
    render_signin: { type: 'render', label: 'Show Sign In Field As', value: 'bestfit' },
  } },
]

@inject('websites')
@observer
export default class Shortcodes extends Component {

  state = {
    selected: 'searchform'
  }

  handleWidgetChange = (event) => {
    this.setState({ selected: event.target.value })
  }

  renderHideNavCss() {
    if (this.state.selected === 'nav') {
      return (
        <div style={{margin: '40px 0'}}>
          <strong>You can also hide the default in-app navigation using this custom CSS:</strong>
          <code>
            <pre style={{ background: '#eee', padding: '10px' }}>
            {`.sidx-main-header:not(.is-widget) {\n  display: none;\n}`}
          </pre>
          </code>
        </div>
      )
    }
  }

  render() {
    const { selected } = this.state
    const widget = widgets.find(w => w.widget === selected)

    return (
      <div className="container padded shortcodes">
        <div className="panel full padded">
          <h2 className="title">Page Builder Shortcodes</h2>

          <div className="form-section">
            <label>
              Please Choose A Widget:
              {' '}
              <select onChange={this.handleWidgetChange}>
                {widgets.map(({ widget, label }) => (
                  <option key={widget} value={widget}>{label}</option>
                ))}
              </select>
            </label>
          </div>
          
          {this.renderHideNavCss()}

          <div className="form-section">
            <ShortcodeGenerator
              key={widget.widget}
              {...widget} />
          </div>

          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Shortcodes/index.js